import React, { useEffect, useState } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import PageTitle from '../components/PageTitle';

const Services = () => {
  // Toggle white text on scroll (black at top) like About/Products
  useEffect(() => {
    const handleScroll = () => {
      const servicesNav = document.getElementById('services-nav');
      if (!servicesNav) return;
      if (window.scrollY > 0) {
        servicesNav.classList.add('scrolled');
      } else {
        servicesNav.classList.remove('scrolled');
      }
    };
    handleScroll();
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const yarnTypes = [
    {
      number: "01",
      title: "Protective & Performance Yarns",
      description: "Engineered for demanding end-uses—cut-resistant, fire-resistant, and performance-driven blends designed for PPE, workwear, and industrial applications."
    },
    {
      number: "02", 
      title: "Specialty & Custom Blends",
      description: "Multi-fiber blends tailored for targeted properties—feel, strength, durability, dyeability—co-developed with your technical teams."
    },
    {
      number: "03",
      title: "Sustainable & Recycled Yarns",
      description: "Organic (GOTS) and recycled (GRS) compositions that balance performance with responsibility and traceable sourcing."
    }
  ];

  const industries = [
    {
      title: "PPE & Safety",
      description: "gloves, sleeves, protective workwear"
    },
    {
      title: "Sports & Athleisure", 
      description: "sports goods & gears."
    },
    {
      title: "Apparel & Knitwear",
      description: "performance basics, uniforms,     fashion knits"
    },
    {
      title: "Home Textiles",
      description: "filtration, reinforcement, and specialty usesr"
    },
    {
      title: "Technical & Industrial",
      description: " durable and sustainable yarn options"
    }
  ];

  return (
    <div style={{ backgroundColor: '#F2F0E6' }}>
      {/* Local navbar overrides for Services page only */}
      <div id="services-nav" className="relative z-50">
        <Navbar />
      </div>

      {/* Hero Section - 30vh like About page */}
      <section style={{ backgroundColor: '#F2F0E6' }} className="relative min-h-[33vh] bg-light flex flex-col pt-32 md:pt-0">
        <div className="flex-1 flex items-center justify-center px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1
              className="heading-responsive font-bold leading-tight"
              style={{
                fontFamily: 'Belleza, serif',
                fontWeight: 400,
                fontStyle: 'normal',
                fontSize: '64px',
                lineHeight: '70px',
                letterSpacing: '0%',
                textAlign: 'center',
                textTransform: 'capitalize',
                color: '#272525'
              }}
            >
              What We Make
            </h1>
            <p
              className="text-responsive-base leading-relaxed mt-4 sm:mt-6"
              style={{
                fontFamily: 'Poppins, sans-serif',
                fontWeight: 400,
                fontStyle: 'normal',
                fontSize: '16px',
                lineHeight: '100%',
                letterSpacing: '0%',
                textAlign: 'center',
                color: '#272525'
              }}
            >
              We specialize in a wide range of synthetic yarns, with focus on consistent quality and reliable service to meet diverse requirements of today's textile industry.
            </p>
          </div>
        </div>
        </section>

      {/* Image Section - Separate from hero with fade effect only on image border */}
      <section style={{ backgroundColor: '#F2F0E6' }} className="relative">
        {/* Fade Effect Overlay on Image - only on the top border */}
        <div 
          className="absolute top-0 left-0 w-full h-16 pointer-events-none z-10"
          style={{
            background: 'linear-gradient(to bottom, #F2F0E6 0%, transparent 100%)'
          }}
        />
        
        <div className="w-full">
          <img 
            src="/WhatsApp Image 2025-09-30 at 11.05.04 AM.jpeg" 
            alt="Yarn spools in textile factory"
            className="w-full h-auto object-cover"
          />
        </div>
      </section>

      {/* Yarn Types Section - Made responsive */}
      <section className="py-12 sm:py-16 md:py-20 lg:py-24 bg-white">
        <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid-responsive-3 gap-8 sm:gap-10 lg:gap-12">
            {yarnTypes.map((yarn, index) => (
              <div key={index} className="relative">
                {/* Small Background Image - Positioned in heading area */}
                <div 
                  className="absolute left-0 top-0 w-12 sm:w-14 md:w-16 h-16 sm:h-18 md:h-20 flex items-center justify-center z-0"
                  style={{ 
                    opacity: 0.6,
                    transform: 'translateY(10%)'
                  }}
                >
                  <img 
                    src={`/${index + 1}.png`}
                    alt={`Background ${index + 1}`}
                    className="w-full h-full object-contain object-left"
                  />
                </div>
                
                {/* Content - Made responsive */}
                <div className="relative z-10 pt-6 sm:pt-8">
                  <h3 
                    className="mb-3 sm:mb-4 subheading-responsive"
                        style={{
                      fontFamily: 'Belleza, serif',
                      fontWeight: '400',
                      color: '#272525'
                    }}
                  >
                    {yarn.title}
                  </h3>
                  <p 
                    className="text-responsive-sm leading-relaxed"
                    style={{ 
                      fontFamily: 'Poppins, sans-serif',
                      fontWeight: '400',
                      color: '#272525'
                        }}
                  >
                    {yarn.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Industries We Serve Section - Made responsive */}
      <section 
        className="py-12 sm:py-16 md:py-20 lg:py-24 pb-48 sm:pb-24 md:pb-28 lg:pb-32"
        style={{ 
          backgroundImage: 'url(/Rectangle 18 (1).png)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat'
        }}
      >
        <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Header */}
          <div className="text-center mb-12 sm:mb-16">
            <h2 
              className="subheading-responsive"
              style={{ 
                fontFamily: 'Belleza, serif',
                fontWeight: '400',
                color: '#272525'
              }}
            >
              Industries We Serve
            </h2>
          </div>

          {/* Industries Grid - Made responsive */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4 sm:gap-6">
            {industries.map((industry, index) => (
              <div 
                key={index}
                className="p-3 sm:p-4 rounded-lg shadow-sm bg-white transition-all duration-300 hover:bg-[#ACAD96] group h-40 sm:h-52 md:h-56 w-full max-w-xs mx-auto sm:max-w-none sm:mx-0"
              >
                <div className="flip-back" style={{ borderRadius: '12px' }}>
                  <div className="px-2 sm:px-3 text-center max-w-md h-full flex flex-col justify-center">
                    <h3
                      className="pt-4 mb-2 text-responsive-base text-[#272525] group-hover:text-white transition-colors duration-300"
                      style={{
                        fontFamily: 'Belleza, serif',
                        fontWeight: '600',
                        fontSize: 'clamp(14px, 1.6vw, 18px)',
                        textAlign: 'center',
                        textTransform: 'capitalize'
                      }}
                    >
                      {industry.title}
                    </h3>
                    {/* Decorative line - same as About page */}
                    <div className="mb-3 flex justify-center">
                      <img 
                        src="/Rectangle 31.png" 
                        alt="Decorative line"
                        className="w-32 h-auto object-contain"
                      />
                    </div>
                    <p
                      className="text-responsive-sm text-[#272525] group-hover:text-white transition-colors duration-300"
                      style={{
                        fontFamily: 'Poppins, sans-serif',
                        fontWeight: '400',
                        textAlign: 'center'
                      }}
                    >
                      {industry.description}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Footer */}
      <div className="relative z-50 -mt-48 md:-mt-0">
        <Footer />
      </div>

      {/* Local CSS overrides for Navbar (Services page only) */}
      <style jsx>{`
        /* Keep navbar elements above content */
        #services-nav nav { position: relative; z-index: 50; }
        #services-nav img[alt="HIK"] { 
          margin-top: 0.5rem !important; 
          position: relative; 
          z-index: 50; 
        }

        @media (min-width: 768px) {
          #services-nav img[alt="HIK"] { 
            margin-top: 1rem !important; 
          }
        }

        /* Default at top of page: black navbar links/buttons */
        #services-nav .md\\:flex a,
        #services-nav .md\\:flex button {
          margin-top: 0.5rem !important;
          color: #272525 !important;
          font-family: Belleza, serif !important;
          font-weight: 400 !important;
          font-size: 20px !important;
          line-height: 100% !important;
        }

        /* Button alignment tweak to match left items */
        #services-nav .md\\:flex button {
          padding-top: 0.375rem !important;
          padding-bottom: 0.375rem !important;
          position: relative; 
          top: -4px;
        }

        /* When scrolled: turn navbar text white */
        #services-nav.scrolled .md\\:flex a,
        #services-nav.scrolled .md\\:flex button {
          color: #ffffff !important;
        }

        /* Mobile responsive adjustments for Industries We Serve section */
        @media (max-width: 640px) {
          .grid.grid-cols-1.sm\\:grid-cols-2.lg\\:grid-cols-3.xl\\:grid-cols-5 > div {
            max-width: 280px !important;
            margin: 0 auto !important;
            padding: 1rem !important;
          }
          
          .grid.grid-cols-1.sm\\:grid-cols-2.lg\\:grid-cols-3.xl\\:grid-cols-5 > div .px-2 {
            padding-left: 1rem !important;
            padding-right: 1rem !important;
          }
        }

        /* Make headings bold on mobile only */
        @media (max-width: 640px) {
          .subheading-responsive {
            font-weight: 600 !important;
          }
        }

        }

      `}</style>
    </div>
  );
};

export default Services;
